<template>
  <div>
    <termoAceite
      :show="show"
      :textTerm="textTerm"
      >
    </termoAceite>
    <dadosLoja
      :show="show"
      :estados="estados"
      >
    </dadosLoja>
    <dominio
      :show="show"
      :technicalIdText="technicalIdText"
    >
    </dominio>
    <pagamento :show="show" />
    <faturamento :show="show" />
    <atendimento :show="show" />
    <marketing :show="show" />
    <logistica :show="show" />
    <apps :show="show" />
    <aparencia
      :show="show"
      :atencao="atencao">
    </aparencia>
  </div>
</template>

<script>
import termoAceite from './../templates/termo-aceite.vue'
import dadosLoja from './../templates/dadosLoja.vue'
import dominio from './../templates/dominio.vue'
import pagamento from './../templates/pagamento.vue'
import faturamento from './../templates/faturamento.vue'
import atendimento from './../templates/atendimento.vue'
import marketing from './../templates/marketing.vue'
import aparencia from './../templates/aparencia.vue'
import logistica from './../templates/logistica.vue'
import apps from './../templates/apps.vue'

export default {
  name: 'Forms',
  components:{
    termoAceite,
    dadosLoja,
    dominio,
    pagamento,
    faturamento,
    atendimento,
    marketing,
    aparencia,
    logistica,
    apps
  },
  data () {
    return {
      show: true,
      textTerm: 'Eu li e concordo com os termos do checklist para criação de Loja Virtual',
      technicalIdText: 'Confirmo cadastro da CheckStore como ID Técnico',
      estados: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'], 
      atencao: "Envie todos os materiais da sua marca para utilizarmos as mesmas cores e padrão editorial na criação da sua loja virtual. Envie sua logomarca (em PNG com fundo transparente, SVG, PDF ou AI), seu favicon (ícone que é exibido na janela do navegador ou nos favoritos: 64x64px), os banners principais da sua loja virtual (conforme o Gabarito dos Banners, além de alguns textos e imagens para criarmos uma página sobre sua marca."
    }
  }
}
</script>
